module.exports = "/client/static/fonts/TitilliumWeb-Bold-3.613987852ab3f0400cabf77450cd94ca.ttf";